export { SimpleForm } from './view/simple-form';
